<app-base-list-page
  [headersList]="headerList"
  (rowClick)="featureClicked($event)"
  [extraBurgerMenuOptions]="extraBurgerMenuOptions"
  [multiSelectFilterLists]="multiSelectFilterLists"
  [createNew]="featureClicked"
  newItemLabel="Tilføj feature til anlæg"
  #baseListPage
></app-base-list-page>
